import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import responseHandler from "responseHandler";
import { MSpinner, MDialog, MDropzone, ActionButtons } from "components/Shared";
import { uploadAppraiserOrderRequirements } from "actions/customerConfigurationAppraisal";

const { PDF } = MDropzone.fileTypes;

const RequirementsUploadDialog = props => {
  const [{ clear, files, errors }, setDropzoneFunctions] = useState({ clear: () => { }, files: [], errors: [] });

  useEffect(() => {
    if (errors.length) {
      for (let error of errors) {
        props.makeToast(error, "error");
      }
    }
  }, [errors]);

  const upload = () => {
    props.uploadAppraiserOrderRequirements(props.customerDetails.number, props.surveyTypeCode, files[0].file);
    props.hideDialog();
  };

  const dialogActions = [
    { disabled: files.length === 0 || errors.length > 0 || !props.surveyTypeCode, onClick: () => upload(), children: "Upload" },
    { disabled: files.length === 0, onClick: () => clear(), children: "Reset" },
    { onClick: props.hideDialog, children: "Cancel" }
  ];

  if (props.fetchingSurveyTypeRequirements) return <MSpinner />;

  return (
    <MDialog
      id="upload-survey-type-requirements"
      className="upload-survey-type-requirements-dialog"
      title="Attach Order Requirements PDF"
      visible={props.visible}
      focusOnMount={false}
      width={550}
    >
      <MDropzone
        className={"survey-requirements-dropzone"}
        setDropzoneProperties={setDropzoneFunctions}
        onFileAdd={() => { }}
        onFileRemove={() => { }}
        prompt="Click here to choose a file to upload"
        validFileTypes={{
          type: PDF,
        }}
        trackFiles
        columnDefinitionOverride={[
          { name: "Name", dataSource: "name", className: "file-name-cell" },
          { name: "Type", dataSource: "extension", style: { width: "50px" } },
        ]}
      />
      <ActionButtons buttonPropSets={dialogActions} />
    </MDialog>
  );
};

RequirementsUploadDialog.propTypes = {
  surveyTypeCode: PropTypes.string,  // Survey type code to attach requirements to
  visible: PropTypes.bool.isRequired, // Show/hide dialog
  hideDialog: PropTypes.func.isRequired,  // Function to call to toggle dialog visibility
  fetchingSurveyTypeRequirements: PropTypes.bool,
  customerDetails: PropTypes.object,
};

const mapStateToProps = state => ({
  fetchingSurveyTypeRequirements: state.customer.fetchingSurveyTypeRequirements,
  customerDetails: state.customer.customerDetails,
});

const mapDispatchToProps = dispatch => ({
  makeToast(text, type) {
    responseHandler.customToast(text, type, dispatch);
  },
  uploadAppraiserOrderRequirements(customerNumber, surveyTypeCode, payload) {
    dispatch(uploadAppraiserOrderRequirements(customerNumber, surveyTypeCode, payload));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(RequirementsUploadDialog);
